module.exports = __webpack_public_path__ + "img/thumbnail_GiantPanda_j_normal.f0832b1b.png";